import { Button, Grid } from "@mui/material";
import React, { useState } from "react";
import {
  // Grid,
  GridDropZone,
  GridItem,
  swap,
  move,
} from "react-grid-dnd";
import reportbuilder from "../ReportBuilder.module.css";
import DropDimensionsTable from "./DropDimensionsTable.jsx";
import { useSelector, useDispatch } from "react-redux";
import { setDimensionVal } from "../../../reduxStore/reducer.js";
import "../style.css";

const ReportDimension = () => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.selectedDimensions.dimensionsVal);
  const [newBottomArr, setNewBottomArr] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  // const [items, setItems] = useState();
  const handelMouseUp = (e) => {
    console.log("no drag");
    e.preventDefault();
    setIsDragging(false);
    document.getElementById('draggableDiv').style.overflowY = 'hidden';
    document.getElementById('draggableDiv').style.overflowX = 'hidden';
  };

  const handelMouseDown = (e) => {
    console.log("dragging ");
    e.preventDefault();
    setIsDragging(true);
    document.getElementById('draggableDiv').style.overflowY = 'visible';
    document.getElementById('draggableDiv').style.overflowX = 'hidden';

  };
  console.log("items", items[0]);

  const addHandeler = (clickedObj) => {
    //  setNewBottomArr((prev) => [...prev, clickedObj]);
    let newBottomArr = [...items[0].dimensionBottom, clickedObj];
    console.log("newBottomArr...", newBottomArr);
    const newDimensionTopArr = items[0].dimensionTop.filter(
      (item) => item.id !== clickedObj.id
    );
    //  setItems({
    //    ...items,
    //    dimensionBottom: newBottomArr,
    //    dimensionTop: newDimensionBottomArr,
    //  });
    console.log("items inside handler fun", items);
    dispatch(
      setDimensionVal([
        {
          ...items[0],
          ["dimensionBottom"]: newBottomArr,
          ["dimensionTop"]: newDimensionTopArr,
        },
      ])
    );
  };

  console.log("newBottomArr..................", newBottomArr);

  return (
    <Grid className="dimBoxRB" xs={12} sx={{ display:"block", height:"17vh"}}>
      <p>Dimensions</p>

      <div className={reportbuilder.dropzone} id="draggableDiv">
        {/* <p>Dimensions</p> */}

        <GridDropZone
          className="dropzone"
          id="dimensionTop"
          boxesPerRow={6}
          rowHeight={40}
          sx={{overflow:"hidden"}}
        >
          {items[0].dimensionTop.map((item) => (
            <GridItem style={{zIndex:100}} key={item.name}>
              <Button
                className={reportbuilder.gridcontent}
                sx={{ 
                  // bgcolor: "#F3F8FC", 
                color: "#000",  fontSize:"12px" }}
                key={item.id}
                onClick={() => {
                  addHandeler(item);
                }}
                onMouseDown={handelMouseDown}
                onMouseUp={handelMouseUp}
              >
                <span>+</span>
                <span>{item.name}</span>
              </Button>
            </GridItem>
          ))}
        </GridDropZone>
      </div>
      {/* <DropDimensionsTable /> */}
    </Grid>
  );
};

export default ReportDimension;
